document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ProductForm').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(this);
      const submitButton = this.querySelector('.quick-add-cart');
      if (submitButton) submitButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(() => {
        // Open the sidebar cart
        const cartTrigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
        if (cartTrigger) cartTrigger.click();

        // Update cart count
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const countElement = document.querySelector('[data-cart-count]');
            if (countElement) countElement.textContent = cart.item_count;

            // Reload sidebar-cart HTML from full page
            fetch(window.location.href)
              .then(res => res.text())
              .then(html => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;

                const newDrawer = tempDiv.querySelector('#sidebar-cart');
                const currentDrawer = document.querySelector('#sidebar-cart');

                if (newDrawer && currentDrawer) {
                  currentDrawer.innerHTML = newDrawer.innerHTML;
                }
              });
          });

        if (submitButton) submitButton.disabled = false;
      })
      .catch(err => {
        console.error('Add to cart failed:', err);
        if (submitButton) submitButton.disabled = false;
      });
    });
  });
});